import { Link } from 'react-router-dom';
import LegalLayout from './LegalLayout';
import { legalConfig } from './legalConfig';

export default function TermsPage() {
  return (
    <LegalLayout title="Điều khoản sử dụng">
      <p className="mb-3">
        Điều khoản này là thoả thuận giữa bạn và {legalConfig.company} về việc sử dụng ứng dụng{' '}
        <strong>EBD Learning</strong> và các dịch vụ trực tuyến đi kèm.
      </p>

      <h2 className="mt-9 mb-3 border-b border-slate-200 pb-2 text-xl font-semibold dark:border-slate-700">
        1. Chấp nhận điều khoản
      </h2>
      <p className="mb-3">
        Khi tạo tài khoản, đăng nhập hoặc sử dụng ứng dụng, bạn xác nhận đã đọc, hiểu và đồng ý với điều
        khoản này cùng{' '}
        <Link className="text-blue-700 dark:text-blue-400" to="/privacy">
          Chính sách bảo mật
        </Link>
        . Nếu bạn dưới 16 tuổi, việc sử dụng phải
        có sự đồng ý của cha mẹ, người giám hộ hoặc nhà trường quản lý tài khoản của bạn.
      </p>

      <h2 className="mt-9 mb-3 border-b border-slate-200 pb-2 text-xl font-semibold dark:border-slate-700">
        2. Tài khoản
      </h2>
      <ul className="mb-3 list-disc space-y-1.5 pl-6">
        <li>Mỗi người dùng sử dụng một tài khoản riêng. Tài khoản học sinh có thể do nhà trường tạo và cấp phát.</li>
        <li>Bạn chịu trách nhiệm giữ bí mật mật khẩu và mọi hoạt động phát sinh từ tài khoản của mình.</li>
        <li>Thông tin bạn cung cấp phải chính xác và được cập nhật khi có thay đổi.</li>
        <li>Thông báo ngay cho chúng tôi khi phát hiện tài khoản bị sử dụng trái phép.</li>
      </ul>

      <h2 className="mt-9 mb-3 border-b border-slate-200 pb-2 text-xl font-semibold dark:border-slate-700">
        3. Giấy phép sử dụng nội dung
      </h2>
      <p className="mb-3">
        Chúng tôi cấp cho bạn quyền sử dụng cá nhân, không độc quyền, không được chuyển nhượng đối với
        ứng dụng và các sách, học liệu mà bạn đã được cấp phép, chỉ nhằm mục đích học tập và giảng dạy.
      </p>
      <ul className="mb-3 list-disc space-y-1.5 pl-6">
        <li>Sách được mở khoá bằng mã kích hoạt do nhà trường hoặc đơn vị phát hành cấp.</li>
        <li>Mã kích hoạt gắn với một tài khoản, không dùng lại cho tài khoản khác và không có giá trị chuyển nhượng.</li>
        <li>Quyền truy cập nội dung có thể có thời hạn theo gói học liệu hoặc theo thoả thuận với nhà trường.</li>
        <li>Nội dung tải về chỉ được dùng trong ứng dụng và bị xoá quyền truy cập khi giấy phép hết hiệu lực.</li>
      </ul>

      <h2 className="mt-9 mb-3 border-b border-slate-200 pb-2 text-xl font-semibold dark:border-slate-700">
        4. Giới hạn thiết bị
      </h2>
      <p className="mb-3">
        Để bảo vệ bản quyền, mỗi tài khoản chỉ được sử dụng trên số lượng thiết bị giới hạn. Ứng dụng ghi
        nhận thiết bị khi bạn đăng nhập; khi vượt quá giới hạn, bạn cần gỡ bớt thiết bị cũ trước khi thêm
        thiết bị mới.
      </p>

      <h2 className="mt-9 mb-3 border-b border-slate-200 pb-2 text-xl font-semibold dark:border-slate-700">
        5. Hành vi bị cấm
      </h2>
      <p className="mb-3">Khi sử dụng dịch vụ, bạn không được:</p>
      <ul className="mb-3 list-disc space-y-1.5 pl-6">
        <li>Sao chép, tải xuống ngoài ứng dụng, in ấn, phát tán, bán lại hoặc công khai nội dung sách và học liệu.</li>
        <li>Dịch ngược, giải mã, can thiệp vào cơ chế mã hoá hoặc cơ chế bảo vệ bản quyền của ứng dụng.</li>
        <li>Chia sẻ tài khoản, mật khẩu hoặc mã kích hoạt cho người khác.</li>
        <li>Dùng công cụ tự động để truy cập, thu thập dữ liệu hoặc gây quá tải hệ thống.</li>
        <li>Tải lên hoặc phát tán nội dung vi phạm pháp luật, xâm phạm quyền của người khác.</li>
        <li>Sử dụng dịch vụ cho mục đích thương mại khi chưa có văn bản đồng ý của chúng tôi.</li>
      </ul>

      <h2 className="mt-9 mb-3 border-b border-slate-200 pb-2 text-xl font-semibold dark:border-slate-700">
        6. Sở hữu trí tuệ
      </h2>
      <p className="mb-3">
        Ứng dụng, mã nguồn, giao diện, thương hiệu EBD Learning cùng toàn bộ sách và học liệu thuộc quyền
        sở hữu của {legalConfig.company} hoặc của các nhà xuất bản, tác giả đã cấp phép cho chúng
        tôi. Điều khoản này không chuyển giao bất kỳ quyền sở hữu nào cho bạn.
      </p>

      <h2 className="mt-9 mb-3 border-b border-slate-200 pb-2 text-xl font-semibold dark:border-slate-700">
        7. Nội dung do người dùng tạo
      </h2>
      <p className="mb-3">
        Ghi chú, đánh dấu trang và bài làm bạn tạo trong ứng dụng thuộc về bạn. Bạn cho phép chúng tôi lưu
        trữ, xử lý và hiển thị các nội dung này trong phạm vi cần thiết để vận hành dịch vụ, đồng bộ giữa
        các thiết bị của bạn và báo cáo kết quả học tập cho giáo viên hoặc phụ huynh có liên quan.
      </p>

      <h2 className="mt-9 mb-3 border-b border-slate-200 pb-2 text-xl font-semibold dark:border-slate-700">
        8. Tạm ngừng và chấm dứt
      </h2>
      <ul className="mb-3 list-disc space-y-1.5 pl-6">
        <li>Bạn có thể ngừng sử dụng và yêu cầu xoá tài khoản bất kỳ lúc nào.</li>
        <li>Chúng tôi có thể tạm khoá hoặc chấm dứt tài khoản vi phạm điều khoản này, đặc biệt là các hành vi xâm phạm bản quyền nội dung.</li>
        <li>Khi tài khoản chấm dứt, quyền truy cập sách và học liệu đã cấp phép cũng chấm dứt.</li>
        <li>Với tài khoản do nhà trường cấp, quyền sử dụng có thể chấm dứt khi thoả thuận giữa chúng tôi và nhà trường kết thúc.</li>
      </ul>

      <h2 className="mt-9 mb-3 border-b border-slate-200 pb-2 text-xl font-semibold dark:border-slate-700">
        9. Thay đổi dịch vụ
      </h2>
      <p className="mb-3">
        Chúng tôi có thể bổ sung, thay đổi hoặc ngừng một số tính năng nhằm cải thiện dịch vụ. Với thay đổi
        ảnh hưởng đáng kể tới quyền lợi của bạn, chúng tôi sẽ thông báo trước qua ứng dụng hoặc email.
      </p>

      <h2 className="mt-9 mb-3 border-b border-slate-200 pb-2 text-xl font-semibold dark:border-slate-700">
        10. Miễn trừ và giới hạn trách nhiệm
      </h2>
      <p className="mb-3">
        Dịch vụ được cung cấp trên cơ sở hiện trạng. Chúng tôi nỗ lực duy trì hệ thống hoạt động ổn định
        nhưng không cam kết dịch vụ không bị gián đoạn hay hoàn toàn không có lỗi. Chúng tôi không chịu
        trách nhiệm với thiệt hại phát sinh từ việc bạn sử dụng sai, để lộ mật khẩu, sự cố thiết bị, đường
        truyền mạng hoặc các nguyên nhân bất khả kháng nằm ngoài khả năng kiểm soát hợp lý của chúng tôi.
      </p>

      <h2 className="mt-9 mb-3 border-b border-slate-200 pb-2 text-xl font-semibold dark:border-slate-700">
        11. Luật áp dụng và giải quyết tranh chấp
      </h2>
      <p className="mb-3">
        Điều khoản này được điều chỉnh bởi pháp luật Việt Nam. Các bên ưu tiên giải quyết tranh chấp bằng
        thương lượng; nếu không đạt được thoả thuận, tranh chấp sẽ được đưa ra toà án có thẩm quyền tại
        Việt Nam.
      </p>

      <h2 className="mt-9 mb-3 border-b border-slate-200 pb-2 text-xl font-semibold dark:border-slate-700">
        12. Thay đổi điều khoản
      </h2>
      <p className="mb-3">
        Bản điều khoản mới nhất luôn được đăng tại trang này kèm ngày hiệu lực. Việc bạn tiếp tục sử dụng
        dịch vụ sau khi điều khoản được cập nhật đồng nghĩa với việc bạn chấp nhận nội dung mới.
      </p>

      <h2 className="mt-9 mb-3 border-b border-slate-200 pb-2 text-xl font-semibold dark:border-slate-700">
        13. Liên hệ
      </h2>
      <p className="mb-3">
        {legalConfig.company}
        <br />
        Mã số doanh nghiệp: {legalConfig.taxCode}
        <br />
        Địa chỉ: {legalConfig.address}
        <br />
        Email:{' '}
        <a className="text-blue-700 dark:text-blue-400" href={`mailto:${legalConfig.email}`}>
          {legalConfig.email}
        </a>
        <br />
        Điện thoại: {legalConfig.phone}
      </p>
    </LegalLayout>
  );
}
